// extracted by mini-css-extract-plugin
export default {"badge":"ProjectBadge_badge__50Mmq"};